export const hideOnMobile = (display = 'flex') => ({
  display: { xs: 'none', sm: display },
});

export const showOnlyInMobile = (display = 'flex') => ({
  display: { xs: display, sm: 'none' },
});

const styles = {
  hideOnMobile,
  showOnlyInMobile,
};
export default styles;
